import React, { useState, useEffect, useRef } from "react"
import { render } from "react-dom"
import "./frontend.css"

const opcFaqDivsToUpdate = document.querySelectorAll(".template-faq-update-me")

let count = 1

opcFaqDivsToUpdate.forEach( div => {
    const data = JSON.parse(div.querySelector("pre").innerHTML) 
    const accordionName = `accordion${count.toString()}`
    const dataToRender = {...data, accordionName}
    render(<FaqBlock {...dataToRender}/>, div)
    div.classList.remove(".long-list-block-update-me")
    count ++    
})

function FaqBlock(props){
    const {heading, questions, accordionName} = props
    const faqHeadingRef = useRef(null)

    useEffect( () => {
        faqHeadingRef.current.innerHTML = heading
    }, [])

    return(
        <>
            <h2 ref={faqHeadingRef}>FAQ</h2>
            <div className="container">
                <div className="jumbotron">
                    {
                        questions.map( (question, index) => {
                            const inputId = `${accordionName}${index}`                            
                            return (
                                <>
                                { 
                                index === (questions.length - 1) ? 
                                <div key={index}>
                                    <input type="radio" name={accordionName} id={inputId} className="accordion__input" checked/>
                                    <label for={inputId} class="accordion__label">
                                        <div className="question">                                
                                            <p>{question.question}</p>
                                        </div>
                                    </label>
                                    <div className="jumbotron-card">
                                        <div className="jumbtron-para">                                
                                            <p>{question.answer}</p>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div key={index}>
                                    <input type="radio" name={accordionName} id={inputId} className="accordion__input"/>
                                    <label for={inputId} class="accordion__label">
                                        <div className="question">                                
                                            <p>{question.question}</p>
                                        </div>
                                    </label>
                                    <div className="jumbotron-card">
                                        <div className="jumbtron-para">                                
                                            <p>{question.answer}</p>
                                        </div>
                                    </div>
                                </div>
                                }
                                </>
                            )
                        }                          
                    
                        )
                    }
                    
                </div>
            </div>        
        </>
    )
}